<template>
  <div>
    <documents-crud-list title="Modèles" category="Modèles" />
  </div>
</template>

<script>
import DocumentsCrudList from './UIComponents/DocumentsCrudList.vue';

export default {
  components: {
    DocumentsCrudList,
  },
};
</script>
